import { alpha, Chip } from '@mui/material'
import { getTestId } from '@utils/helpers'

export default function RecommendationChip({ recommended, ...rest }: { recommended: boolean }) {
	const chipColor = recommended ? 'success.dark' : 'error.dark'
	const testId = getTestId(rest, recommended ? 'recommend-chip' : 'decline-chip')
	const chipBackground = (theme) =>
		alpha(recommended ? theme.palette.success.dark : theme.palette.error.dark, 0.08)

	return (
		<Chip
			label={recommended ? 'Recommend' : 'Decline'}
			data-testid={testId}
			sx={{ width: 'fit-content', color: chipColor, bgcolor: chipBackground }}
		/>
	)
}
